<div class="list">
  <div class="title">
    <h4 [translate]="'references.Title'"></h4>
  </div>
  <div class="tab">
    <div *ngFor="let ref of sortedResults" class="reference" (click)="SelectReference(ref)">
      <div class="top">
        <label class="manufacturer"><img class="logo" src="assets/Logo/low/{{ref.logoName.replace('.BMP','.png')}}" alt="" aria-hidden="true" />{{ref.manufacturer}}</label>
        <label class="code" [translate]="'references.code'" [translateParams]="{code: ref.code}"></label>
      </div>
      <div class="bottom">
        <label class="designation">{{ref.designation}}</label>
        <label class="date">{{ref.dateFrom}} <i aria-hidden="true" class="fas fa-arrow-right"></i>{{ref.dateTo}}</label>
      </div>
    </div>
  </div>

  <table mat-table class="tablist" [dataSource]="sortedResults" matSort (matSortChange)="sortReferences($event)" fixedLayout>
    <ng-container matColumnDef="manufacturer">
      <th mat-header-cell *matHeaderCellDef [mat-sort-header]="manufacturer">{{'common.manufacturer'|translate}}</th>
      <td mat-cell class="left" *matCellDef="let res"><img class="logo" src="assets/Logo/low/{{res.logoName.replace('.BMP','.png')}}" alt="" aria-hidden="true"/>{{res.manufacturer}}</td>
    </ng-container>

    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef [mat-sort-header]="code">{{'common.code'|translate}}</th>
      <td mat-cell *matCellDef="let res">{{res.code}}</td>
    </ng-container>

    <ng-container matColumnDef="designation">
      <th mat-header-cell *matHeaderCellDef [mat-sort-header]="designation">{{'common.designation'|translate}}</th>
      <td mat-cell *matCellDef="let res" class="left">{{res.designation}}</td>
    </ng-container>

    <ng-container matColumnDef="dateFrom">
      <th mat-header-cell *matHeaderCellDef [mat-sort-header]="dateFrom">{{'common.from'|translate}}</th>
      <td mat-cell *matCellDef="let res">{{res.dateFrom}}</td>
    </ng-container>

    <ng-container matColumnDef="dateTo">
      <th mat-header-cell *matHeaderCellDef [mat-sort-header]="dateTo">{{'common.to'|translate}}</th>
      <td mat-cell *matCellDef="let res">{{res.dateTo}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="SelectReference(row)"></tr>
  </table>
</div>
